module.exports = __webpack_public_path__ + "static/media/logo-(primary-gradient).ecb897fd.png";